<script setup>
import { ClockIcon, ExclamationTriangleIcon, SignalSlashIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n.js'

const { locale, t } = useI18n()

defineProps({ alerts: { type: Array, default: () => [] } })
const emit = defineEmits(['show-all'])

function dateTime(value) {
  if (!value) return t('pts2UiTimeUnknown')
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat(locale.value, {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }).format(date).replace(',', '')
}

function severityLabel(value) {
  if (value === 'critical') return t('pts2UiCritical')
  if (value === 'info') return t('pts2UiInformation')
  return t('pts2UiWarning')
}
</script>

<template>
  <section class="pts2-side-card pts2-alerts-card" aria-labelledby="pts2-alerts-title">
    <h2 id="pts2-alerts-title">{{ t('pts2UiActiveAlerts') }} <span>· {{ alerts.length }}</span></h2>
    <div v-if="alerts.length" ref="list" class="pts2-alert-list">
      <article v-for="alert in alerts" :key="alert.id" class="pts2-alert-row" :class="alert.severity">
        <span class="pts2-alert-icon">
          <SignalSlashIcon v-if="alert.severity === 'critical'" aria-hidden="true" />
          <ExclamationTriangleIcon v-else aria-hidden="true" />
        </span>
        <span class="pts2-alert-copy">
          <strong>{{ alert.title }}</strong>
          <small><ClockIcon aria-hidden="true" />{{ dateTime(alert.eventAt) }}</small>
        </span>
        <span class="pts2-alert-severity">{{ severityLabel(alert.severity) }}</span>
      </article>
    </div>
    <p v-else class="pts2-inline-empty compact">{{ t('pts2UiNoAlerts') }}</p>
    <button class="pts2-primary-action" type="button" :disabled="!alerts.length" @click="emit('show-all')">
      {{ t('pts2UiViewAlerts') }}
    </button>
  </section>
</template>
